{
  "aiDetectionPoller": {
    "outsideScheduleStatusText": "検知時間外のため待機中",
    "error": "全カメラの AI 検知 event fetch に失敗しました"
  },
  "viewerAiDetectionDialog": {
    "text": "エリア未設定",
    "text2": "映像で再編集",
    "text3": "オン（映像で指定）",
    "setErrorMessage": "検知範囲の指定は1台選択時のみ利用できます",
    "text4": "カスタム検知数{{custom}}/{{limit}}",
    "text5": "定型検知数{{template}}/{{limit}}",
    "text6": "検知タイトルを入力してください",
    "text7": "検知タイトルは{{MAX_TITLE_LENGTH}}文字以内で入力してください",
    "text8": "対象カメラを選択してください",
    "text9": "AI検知がONのカメラのみ選択できます",
    "text10": "{{cameraName}} はこれ以上検知設定を追加できません",
    "text11": "カスタム検知は最大{{customLimit}}件までです",
    "text12": "検知対象を入力してください",
    "text13": "検知条件を入力してください",
    "text14": "定型検知は最大{{templateLimit}}件までです",
    "text15": "検知条件数は1以上の数値を入力してください",
    "text16": "侵入検知エリアを設定してください",
    "text17": "侵入検知エリアは縦横それぞれ{{value}}%以上で設定してください",
    "text18": "検知範囲の指定は対象カメラを選択してから設定してください",
    "text19": "検知範囲は最大{{MAX_ROI_COUNT}}個までです",
    "text20": "検知範囲は縦横それぞれ{{value}}%以上で設定してください",
    "text21": "検知終了日時を入力してください",
    "text22": "検知終了日時は検知開始日時より後にしてください",
    "text23": "検知終了時刻は検知開始時刻より後にしてください",
    "text24": "検知時間スケジュールを設定してください",
    "setErrorMessage2": "対象カメラのエリア情報を解決できませんでした",
    "setErrorMessage3": "対象カメラの tenantCameraId を解決できませんでした",
    "text25": "検知設定の保存に失敗しました",
    "text26": "検知を編集",
    "text27": "カスタム検知を追加",
    "text28": "検知設定を読み込んでいます",
    "text29": "検知設定を更新しています",
    "text30": "検知設定を保存しています",
    "label": "検知タイトル（10文字以内）",
    "label2": "検知の種類",
    "menuItem": "人数検知",
    "menuItem2": "ヘルメット未着用検知",
    "menuItem3": "侵入検知",
    "label3": "検知条件数",
    "label4": "比較条件",
    "menuItem4": "以上",
    "menuItem5": "超",
    "text31": "対象カメラ",
    "alert": "AI検知がONのカメラがありません",
    "alert2": "侵入検知は対象カメラを1台選び、映像上で侵入エリアを指定します。",
    "text32": "侵入範囲",
    "button": "映像で範囲を編集",
    "button2": "リセット",
    "button3": "クリア",
    "text33": "映像上で矩形をドラッグして検知範囲を指定できます。",
    "text34": "検知範囲の指定",
    "button4": "オフ",
    "label5": "検知開始日時",
    "label6": "検知終了日時",
    "label7": "終了日なし",
    "label8": "検知時間",
    "menuItem6": "終日",
    "menuItem7": "時間帯を指定",
    "menuItem8": "スケジュールを指定",
    "label9": "開始時刻",
    "label10": "終了時刻",
    "button5": "編集する",
    "label11": "通知メールを送信する",
    "label12": "通知メール送信先",
    "label13": "通知タイミング",
    "menuItem9": "初回検知時のみ通知",
    "menuItem10": "1時間ごとにまとめて通知",
    "text35": "検知間隔が1分以上のカメラでは、初回通知か1時間まとめ送信を選べます。",
    "text36": "検知間隔が1分未満のカメラでは、初回検知時のみ通知します。",
    "text37": "検知頻度:",
    "text38": "読込中...",
    "text39": "更新中...",
    "text40": "実行中...",
    "text41": "実行"
  },
  "viewerAiResultListItem": {
    "text": "AI検知結果画像を拡大",
    "alt": "AI検知結果",
    "text2": "人",
    "meterEvent": "閾値イベント ({{transition}})",
    "meterReading": "数値履歴",
    "rising": "開始",
    "falling": "解除",
    "ongoing": "継続"
  },
  "viewerAiRightRail": {
    "label": "検知時刻",
    "label2": "カメラ",
    "label3": "検知",
    "label4": "結果",
    "text": "このアカウントでは検知結果を参照できません。",
    "text2": "このカメラでは検知結果を表示できません。",
    "title": "検知条件: {{value}}",
    "text3": "シークバーに表示",
    "text4": "条件",
    "text5": "条件を折りたたむ",
    "text6": "条件を展開する",
    "label5": "検知対象:",
    "label6": "検知条件:",
    "label7": "対象カメラ:",
    "label8": "期間:",
    "text7": "管理画面で結果を見る",
    "text8": "結果を読み込んでいます",
    "text9": "結果はまだありません",
    "text10": "直近",
    "text11": "件の結果を表示しています",
    "imageAlt": "AI検知結果",
    "text12": "AI検知結果 {{previewTimestampLabel}}"
  },
  "viewerAiSettingsMenu": {
    "text": "検知{{value}}",
    "text2": "カメラ未設定",
    "alert": "このアカウントでは viewer 内の AI 機能を利用できません。",
    "text3": "このカメラではAI機能がオフです",
    "text4": "ご利用についてはお問い合わせください。",
    "text5": "※ご利用にはオプション契約が必要です。",
    "text6": "検知",
    "text7": "最新検知時刻:",
    "text8": "対象カメラ",
    "text9": "通知設定",
    "text13": "検知期間",
    "text14": "検知時間帯",
    "text15": "検知頻度",
    "text16": "結果を見る",
    "text17": "停止",
    "ariaLabel": "AI検知設定",
    "ariaLabel2": "AI検知設定を閉じる",
    "text18": "AI検知情報を読み込んでいます",
    "text19": "カスタム検知を追加",
    "text20": "稼働中の検知（カスタム",
    "text21": "稼働中の検知はありません",
    "text22": "上の追加ボタンから設定してください。",
    "text23": "参照できる稼働中の検知はありません。",
    "text24": "メーター",
    "text25": "メーターはここから停止できます。設定の変更・停止後の再開は管理者に依頼してください。専用処理の再検証が必要です。",
    "meterReadOnlyGuidance": "メーター設定の変更・停止・再開は管理者に依頼してください。",
    "cameraInterval": "カメラのAI設定に従う"
  },
  "viewerRoiEditorOverlay": {
    "button": "完了",
    "alert": "映像情報を取得中です",
    "button2": "確定",
    "button3": "範囲を追加",
    "text": "縦横それぞれ{{value}}%以上で指定してください",
    "button4": "選択中の範囲を削除",
    "text2": "{{rectLabel}}（確定前）",
    "text3": "映像上をドラッグして範囲を指定できます",
    "text4": "映像上をドラッグすると範囲を追加できます。既存の範囲はクリックで選択して移動・サイズ変更できます"
  },
  "aiDisabledSupport": {
    "aiDisabledSupportMessage": "このカメラではAI機能がオフです。ご利用についてはお問い合わせください。",
    "aiUnconfiguredSupportMessage": "このカメラにはAI設定がありません。設定状況をご確認ください。",
    "aiDisabledSupportActionLabel": "利用について問い合わせる",
    "aiDisabledSupportInlineLabel": "お問い合わせ方法",
    "aiUnconfiguredSupportLead": "このカメラには画像検知設定が登録されていません",
    "aiUnconfiguredSupportFootnote": "※画像検知を利用するにはカメラ設定の登録が必要です。"
  },
  "roi": {
    "roiEditorGuideMessage": "映像上で検知範囲を指定してください",
    "roiEditorAddGuideMessage": "映像上をドラッグして新しい検知範囲を描いてください",
    "roiEditorConfirmGuideMessage": "この範囲で確定しますか？",
    "roiEditorRectLabel": "検知範囲",
    "intrusionRoiEditorRectLabel": "侵入検知エリア",
    "text": "未設定",
    "text2": "{{length}}個の範囲を指定済み"
  },
  "viewerAiPresentation": {
    "text": " / 最終確認: {{lastCheckedAt}}",
    "text2": " / 状態: {{lastThresholdState}}",
    "text3": "サーバ検知{{checkedAt}}{{threshold}}",
    "text4": "ヘルメット検知",
    "text5": "侵入検知",
    "text6": "カスタム検知",
    "text7": "人数検知",
    "text8": "AI検知",
    "text9": "未設定",
    "text11": "ヘルメット",
    "text12": "侵入",
    "text13": "カスタム",
    "text14": "人数",
    "text15": "人数: {{peopleCount}}",
    "text16": "侵入検知: {{value}}",
    "text17": "LLM検知イベント",
    "text18": "侵入を検知 ({{value}})",
    "text19": "人数 {{peopleCount}}人",
    "text20": "未着用 {{helmetMissingCount}}件",
    "text21": "しきい値が正常に戻りました",
    "text22": "しきい値を超過しました",
    "text23": "AI検知イベント",
    "meterConditionDisabled": "閾値イベントは無効"
  },
  "viewerAiSettingsMenuLayout": {
    "text": "登録できる検知は{{limit}}件です。新しく追加するには、既存の検知を停止してください。",
    "text2": "未取得"
  }
}
